var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvidenceTests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    strokeWidth: 3,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.4H19C19.5523 7.4 20 6.95228 20 6.4V3C20 2.44772 19.5523 2 19 2H9C8.44772 2 8 2.44772 8 3V6.4C8 6.95228 8.44772 7.4 9 7.4H10M18 7.4V13.9526C18 14.5089 18.2317 15.04 18.6394 15.4185L25.3606 21.6565C25.7683 22.035 26 22.5661 26 23.1224V27C26 28.1046 25.1046 29 24 29H4C2.89543 29 2 28.1046 2 27V23.1224C2 22.5661 2.2317 22.035 2.63945 21.6565L9.36055 15.4185C9.7683 15.04 10 14.5089 10 13.9526V7.4M18 7.4H10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvidenceTests);
export default __webpack_public_path__ + "static/media/evidence-tests.016bfb101fc61c7be72a180c6ea60568.svg";
export { ForwardRef as ReactComponent };